import { setupListeners } from '@reduxjs/toolkit/query';
import { createAsyncStore } from './createAsyncStore';

const store = createAsyncStore();
setupListeners(store.dispatch);

export type AppState = ReturnType<typeof store.getState> & { [slice: string]: any };
export type AppDispatch = typeof store.dispatch

/** Для createSelector
 * @example
 * const someSelector: CreateSelector<number> = createSelector(...)
 * const someSelector2 = (id: number):CreateSelector<number> => createSelector(...)
*/
export type CreateSelector<T> = (state: AppState) => T;

export default store;
